import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export type I18nLocale = {
  code: string;
  displayName: string;
  enabled: boolean;
  isDefaultAdminUi: boolean;
};

async function fetchLocales(): Promise<I18nLocale[]> {
  const res = await apiClient.get<I18nLocale[]>('/i18n/locales');
  return res.data;
}

export function useLocales() {
  return useQuery({
    queryKey: ['i18n', 'locales'],
    queryFn: fetchLocales,
  });
}
